<template>
    <nav>
      <div class="container mb-4" id="nav">
        <div class="logo-float d-none d-xl-block">
          <img src="./assets/svg/logo.svg" alt="logo"/>
        </div>
        <div class="d-flex "> 
        </div>
        <div>
          <!-- <a
            :href="`/crear_cuenta`"
            class="btn btn-link btn-sm mr-2 text-light d-none d-md-inline"
            >Crear una cuenta</aa
          > -->
          <a href="https://welcome.alliance-cloud.com/passport/login" class="btn btn-primary btn-sm">
            <i class="ri-login-box-fill small mr-1"></i> Iniciar sesión
          </a> 
        </div>
      </div>
    </nav> 
    <div class="spacer">
      <div class="container mx-0">
          <div class="row no-gutters">
            <div class="col-12 col-md-5">
              <h1 ref="title" class="position-relative text-2xl">
                ¿En qué país está registrada tu empresa?
              </h1>

              <ul class="lista mt-3">
                <li > 
                  <router-link to="/ve" class="link p-2 rounded">
                        <span class="fi fi-ve"></span> <span class="ml-2">Venezuela</span>
                    </router-link>  
                </li>
                <li>
                    <router-link to="/pa" class="link p-2 rounded">
                        <span class="fi fi-pa"></span> <span class="ml-2">Panamá</span> 
                    </router-link>
                </li>
              </ul> 
            </div>
          </div>
      </div>
    </div>
      <div id="cover">
        <div id="canva"></div>
        <div class="container mx-0"> 
        </div>  
          <img
          ref="logoGradient"
          class="logoGradient"
          :src="require(`@/assets/svg/logo-gradient.svg`)"
          alt="logo-gradient"
        />
        <img
          ref="logoOutline"
          class="logoOutline"
          :src="require(`@/assets/svg/logo-outline.svg`)"
          alt="logo-outline"
        />  
      </div>
</template>




<script>
    import "/node_modules/flag-icons/css/flag-icons.min.css";
   export default {
      name: "HomePage",
    
    }
</script>



<style lang="scss">
    
    @use "scss";

    .lista {
        list-style: none;
        font-size: 22px;
    }

    .lista li {
      margin-bottom: 5px;
      padding-left: 20px; 
      
        width: 200px;
    
    }

    .lista .link {
        cursor: pointer;
        width: 200px;
        display: block;
        color: inherit;
        text-decoration: none;
    }
 
 

    .lista .link:hover {
         background-color: #2e73b080;  
        transition: all 0.3s ease;   

    }

</style>



